import React from 'react';
import { motion } from 'framer-motion';
import { X, Check } from 'lucide-react';
export function SolutionReveal() {
  return <section className="py-20 px-4 bg-ivory relative overflow-hidden border-y border-beige" data-id="element-256">
      <div className="absolute top-0 left-1/2 -translate-x-1/2 w-full max-w-3xl h-px bg-gradient-to-r from-transparent via-gold to-transparent opacity-50" data-id="element-257"></div>

      <div className="max-w-4xl mx-auto text-center" data-id="element-258">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} data-id="element-259">
          <div className="inline-flex items-center justify-center w-14 h-14 rounded-full bg-gold/10 text-gold mb-5 border border-gold/20" data-id="element-260">
            <span className="text-2xl" data-id="element-261">🏆</span>
          </div>
          <h2 className="text-2xl md:text-4xl font-serif font-bold mb-4 text-forest" data-id="element-262">
            El sistema más completo de Historia de México para el aula
          </h2>
          <h3 className="text-xl font-bold text-terracotta mb-3" data-id="element-263">
            Mega Pack Historia México 360
          </h3>
          <p className="text-base md:text-lg text-warmgray mb-10 font-medium" data-id="element-264">
            7 tomos · 5 bonos estratégicos · Todo listo para usar desde hoy.
          </p>
        </motion.div>

        <div className="grid md:grid-cols-2 gap-6 text-left" data-id="element-265">
          <motion.div initial={{
          opacity: 0,
          x: -20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} className="space-y-4 bg-white p-6 rounded-2xl border border-beige shadow-sm" data-id="element-266">
            <div className="flex items-start gap-3" data-id="element-267">
              <X className="text-urgent shrink-0 mt-1" size={18} data-id="element-268" />
              <p className="text-warmgray text-sm font-medium" data-id="element-269">
                No es un resumen copiado de Wikipedia.
              </p>
            </div>
            <div className="flex items-start gap-3" data-id="element-270">
              <X className="text-urgent shrink-0 mt-1" size={18} data-id="element-271" />
              <p className="text-warmgray text-sm font-medium" data-id="element-272">
                No es una colección de actividades sueltas sin hilo conductor.
              </p>
            </div>
            <div className="flex items-start gap-3" data-id="element-273">
              <X className="text-urgent shrink-0 mt-1" size={18} data-id="element-274" />
              <p className="text-warmgray text-sm font-medium" data-id="element-275">
                No es material que tengas que adaptar entero antes de poder
                usarlo.
              </p>
            </div>
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          x: 20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} className="bg-forest/5 p-6 rounded-2xl border border-forest/20 relative overflow-hidden" data-id="element-276">
            <div className="absolute top-0 right-0 w-32 h-32 bg-forest/10 blur-3xl rounded-full" data-id="element-277"></div>
            <div className="flex items-start gap-3 relative z-10" data-id="element-278">
              <Check className="text-forest shrink-0 mt-1" size={20} data-id="element-279" />
              <p className="text-forest-dark font-bold text-base leading-relaxed" data-id="element-280">
                Es un sistema para que entres al aula con confianza y dictes
                clases que de verdad conecten a tus alumnos con la historia que
                construyó el México en el que viven.
              </p>
            </div>
          </motion.div>
        </div>
      </div>
    </section>;
}